<template>
    <button
      :class="buttonClasses"
    >
      <img :class="imageStyle" :src="resolvedIcon" alt="" />
    </button>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  
  const props = defineProps({
    icon: {
      type: String,
      required: true,
    },
    buttonClasses: {
      type: String,
      default: 'flex h-[15vmin] w-[15vmin] items-center justify-center rounded-2xl border-2 border-[#636364] bg-[#2a2c32] p-2 text-white transition-colors hover:bg-[#515561] md:h-[4vw] md:w-[4vw]',
    },
    imageStyle: {
      type: String,
      default: '',
    },
  });
  
  const resolvedIcon = computed(() => require(`../assets/icons/${props.icon}`));
  </script>
  
  